<template>
  <!-- 服务事项 -->
  <div class="service-matters">
    <div class="hot-server">
      <headerWarpTheme v-model="hotTabId" :tabList="hotTabList" @click="changeHotServe" @btn-click="goServiceCenter">
        <div class="hot-server-list">
          <template v-if="serviceList.length">
            <span class="server-item" v-for="item in serviceList" :key="item.servId" @click="openServeDetail(item.servId)">
              <span class="item-img">
                <el-image :src="item.src" fit="fill">
                  <div slot="error" class="image-slot">
                    <img :src="require('@/assets/error/defult-head.png')" />
                  </div>
                </el-image>
              </span>
              <span class="item-content">
                <span class="content-title" :title="item.servName">{{item.servName}}</span>
                <span class="content-dep" :title="item.servOrg">{{item.servOrg}}</span>
              </span>
            </span>
          </template>
          <el-empty v-else description="暂无数据"></el-empty>
        </div>
      </headerWarpTheme>
    </div>
    <div class="hot-server">
      <headerWarpTheme v-model="affairId" :size="'small'" :tabList="handleAffairs" @click="changeAffair" @do-click="goServiceCenter">
        <div class="hot-server-list">
          <template v-if="handleAffairsList.length">
            <span class="server-item" v-for="item in handleAffairsList" :key="item.servId" @click="openServeDetail(item.servId)">
              <span class="item-img">
                <el-image :src="item.src" fit="fill">
                  <div slot="error" class="image-slot">
                    <img :src="require('@/assets/error/defult-head.png')" />
                  </div>
                </el-image>
              </span>
              <span class="item-content">
                <span class="content-title" :title="item.servName">{{item.servName}}</span>
                <span class="content-dep" :title="item.servOrg">{{item.servOrg}}</span>
              </span>
            </span>
          </template>
          <el-empty v-else description="暂无数据"></el-empty>
        </div>
      </headerWarpTheme>
    </div>
    <!-- <div class="handle-Affairs">
      <headerWarp v-model="affairId" :tabList="handleAffairs" @click="changeAffair" @do-click="goServiceCenter">
        <div class="handle-Affairs-list">
          <template v-for="(item,index) in handleAffairsList">
            <span class="server-item" v-if="index<14" :key="item.servId" @click="openServeDetail(item.servId)">
              <el-image :src="item.src" fit="fill" class="icon item-img">
                <div slot="error" class="image-slot">
                  <img :src="require('@/assets/error/defult-head.png')" />
                </div>
              </el-image>
              <span class="item-name">{{item.servName}}</span>
            </span>
          </template>
        </div>
        <div class="handle-Affairs-list" v-if="!handleAffairsList.length">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </headerWarp>
    </div> -->
    <service-detail v-if="serviceDialog" :visible.sync="serviceDialog" :serveId="serveId"></service-detail>
  </div>
</template>

<script>
import serviceDetail from "./components/serviceDetail.vue";
import headerWarp from './headerWarp.vue';
import headerWarpTheme from './headerWarpTheme.vue';
import visitorsApi from '@/api/visitors/index';
import { Base64 } from 'js-base64'
export default {
  name: "",
  components: {
    serviceDetail,
    headerWarp,
    headerWarpTheme
  },
  data() {
    return {
      tabsConfig: {
        size: 20,
        local:"left"
      },
      // 展示更多服务分类菜单
      showMoreServiceMenu: false,
      /** 服务详情 */
      serviceDialog: false,
      // 热门、推荐 栏目、数据
      serviceList: [],
      // 热门、推荐 列表
      hotTabList: [
        {id: '1', label: '热门服务'},
        {id: '2', label: '推荐服务'},
      ],
      // 热门、推荐 id
      hotTabId: '1',
      // 三张办事清单
      handleAffairs: [],
      handleAffairsList: [],
      affairId: '',
      serveId: ''
    };
  },
  computed: {

  },
  created() {
    this.queryHotServeList()

    this.queryDynamicType()
  },
  methods: {
    /** 查询热门方法 */
    queryHotServeList() {
      visitorsApi.queryHotServeList().then(res => {
        let hotTabList = []
        for (const key in res.data) {
          hotTabList.push({id: key, label: key, serviceList: res.data[key]})
        }
        this.hotTabList = hotTabList.map(it => {
          it.serviceList = it.serviceList.map(serveItem => {
            serveItem.openUrl = Base64.decode(serveItem.servUrl)
            serveItem.src = Base64.decode(serveItem.servIcon)
            return serveItem
          })
          return it
        })
        this.hotTabId = hotTabList[0].id
        this.serviceList = this.hotTabList[0].serviceList
      })
    },
    /** 热门服务和推荐服务类型切换 */
    changeHotServe(id) {
      this.hotTabList.forEach(it => {
        if(it.id == id) {
          this.serviceList = it.serviceList
        }
      })
    },
    /** 查询办事等栏目列表 */
    queryDynamicType() {
      const parmas = {
        parentTypeCode: 'ROLE'
      }
      visitorsApi.queryDynamicType(parmas).then(res => {
        const datas = res.data[0].children || []
        const handleAffairs = []
        datas.forEach(it => {
          handleAffairs.push({id: it.typeId+'', label: it.typeName})
        })
        this.affairId = handleAffairs[0].id || ''
        this.queryDynamicList()
        this.handleAffairs = handleAffairs
      })
    },
    /** 查询办事栏目得列表 */
    queryDynamicList() {
      const parmas = {
        typeIds: [this.affairId]
      }
      visitorsApi.queryDynamicList(parmas).then(res => {
        this.handleAffairsList = res.data.map(it => {
          it.src = Base64.decode(it.servIcon)
          return it
        })
        this.handleAffairsList = this.handleAffairsList.slice(0,10)
      })
    },
    /** 切换办事类型 */
    changeAffair() {
      this.queryDynamicList()
    },
    /** 跳转服务中心 */
    goServiceCenter() {
      this.$router.push('/visitor-service')
    },
    openServeDetail(id) {
      this.serveId = id
      this.serviceDialog = true
    }
  },
};
</script>

<style lang="less">
// 服务事项
.service-matters {
  width: 100%;
  // background: url('../../../assets/visitors/server-bg.png');
  padding: 30px 13%;
  // margin-top: 30px;
  .hot-server {
    &-list {
      height: 220px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 30px;
      .server-item {
        cursor: pointer;
        height: 80px;
        width: calc((100% - 120px) / 5);
        margin-bottom: 30px;
        margin-right: 30px;
        display: flex;
        padding: 15px 8px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #EEEEEE;
        box-shadow: 0px 0 12px 0px rgba(0,0,0,0.08);
        .item-img {
          width: 50px;
          height: 50px;
        }
        .item-content {
          width: calc(100% - 66px);
          margin-left: 16px;
          display: flex;
          flex-direction: column;
          justify-items: center;
          font-size: 14px;
          .content-title {
            line-height: 20px;
            color: #333333;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 600;
          }
          .content-dep {
            width: 100%;
            line-height: 20px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-top: 6px;
          }
        }
      }
      .server-item:nth-child(5n) {
        margin-right: 0;
      }
    }
  }
  .handle-Affairs {
    margin-top: 30px;
    &-list {
      display: flex;
      flex-wrap: wrap;
      margin-top: 30px;
      .server-item {
        cursor: pointer;
        width: calc(64% / 7);
        margin-right: 6%;
        height: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
        .item-img {
          width: 66px;
          height: 66px;
        }
        .item-name {
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          color: #333333;
          width: 100%;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .server-item:nth-child(7n) {
        margin-right: 0;
      }
    }
  }
}
</style>
